<ng-container>
	<mat-card (cdkDragEnded)="_dragEnd($event);" (mousedown)="_mouseDown($event);" [cdkDragFreeDragPosition]="position" [ngStyle]="_visible()"
			  cdkDrag cdkDragBoundary=".desktop" class="drag-box patter-table panel">
		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button>
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex="">{{title}}</div>
		</div>
		<div *ngIf="!rigid" fxLayout="row" fxLayoutAlign="center">
			<div fxFlex>
				<button (click)="first(1)" [disabled]="!hasprev" class="icon-arrow" color="primary" mat-icon-button id="mat-first-button">
					<mat-icon class="icon">first_page</mat-icon>
				</button>
				<button (click)="prev(1)" [disabled]="!hasprev" class="icon-arrow" mat-icon-button id="mat-prev-button">
					<mat-icon class="icon">keyboard_arrow_left</mat-icon>
				</button>
				<button (click)="next(1)" [disabled]="!hasnext" class="icon-arrow" color="primary" mat-icon-button id="mat-next-button">
					<mat-icon class="icon">keyboard_arrow_right</mat-icon>
				</button>
				<button (click)="last(1)" [disabled]="!hasnext" class="icon-arrow" color="warn" mat-icon-button id="mat-last-button">
					<mat-icon class="icon">last_page</mat-icon>
				</button>
			</div>
		</div>

		<mat-card-content class="panel-content">
			<div *ngIf="locked" cdkDragHandle></div>
			<div *ngIf="patters; else noData">
				<div *ngIf="patters.length > 0; else noData" fxLayout="column" fxLayoutAlign="start">
					<div *ngFor="let patter of patters; index as i">
						<div *ngIf="shots[i].prizm">
							<aigia-patter [active]="_active()" [camera]="camera" [endpoint]="endpoint" [images]="patter" [rigid]="rigid" [size]="size"></aigia-patter>
						</div>
						<div *ngIf="!(shots[i].prizm)" fxLayout="column" fxLayoutAlign="center" style="height:160px;width:400px;">
							<div style="font-size:36px;font-weight:900;color:#808080;">No Image</div>
						</div>
					</div>
				</div>
			</div>
			<ng-template #noData>
				<mat-card>
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>
</ng-container>


